import ChevronDownIcon from '@lemon8/design/lib/icons/icon_assets/chevron_down_fill.svg';
import { Loading } from '~/components/loading';
import { useTranslation } from 'react-i18next';
import cls from 'classnames';
import { ClickPosition } from '~/utils/click-position';
import { useScopedAtomValue } from '@lemon8/web-app-shared/ssr';
import { $CurrentPageModule } from '~/models/current-page-module';
import { $CurrentPositionPrefix } from '~/models/current-position-prefix';

import './style.scss';
import { useEffect, useState } from 'react';

interface SeeMoreProps {
  loading?: boolean;
  onClickSeeMore?: () => void;
}

export const SeeMoreBanner = (props: SeeMoreProps): JSX.Element => {
  const { onClickSeeMore, loading = false } = props;
  const { t } = useTranslation();
  const currentPageModule = useScopedAtomValue($CurrentPageModule);
  const prefix = useScopedAtomValue($CurrentPositionPrefix);

  const onClick = () => {
    window.Tea('wap_click', {
      current_page_module: currentPageModule,
      current_position: prefix + ClickPosition.see_more_button,
    });

    onClickSeeMore?.();
  };

  return (
    <div className={cls('see-more-banner', { 'see-more-banner-loading': loading })} onClick={onClick}>
      {loading ? (
        <div className="see-more-banner-loading-ball">
          <Loading variant={'ball'} />
        </div>
      ) : (
        <>
          <div className="see-more-banner-mask" />
          <div className="see-more-banner-btn">
            <div className="see-more-banner-arrow">
              <div className="see-more-banner-arrow-top">
                <ChevronDownIcon />
              </div>
              <div className="see-more-banner-arrow-down">
                <ChevronDownIcon />
              </div>
            </div>
            <div className="see-more-banner-text">{t('see_more')}</div>
          </div>
        </>
      )}
    </div>
  );
};
